<div class="card-group">
    <div *ngFor="let cat of categories" class="card m-3" (click)="pushToCategory(cat)">
      <img [src]="cat.imgUrl" class="card-img-top" alt="...">
      <div class="card-body">
        <h5 class="card-title">{{cat.name}}</h5>
        <p class="card-text">{{cat.description}}</p>
      </div>
      <div class="card-footer">
        <small class="text-muted">25 productos</small>
      </div>
  </div>